module.exports = __webpack_public_path__ + "media/img/pages/profile/lgt ger 9-ff06d0671b8e1070b6af5dc987cd524f.jpg";